import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Max } from "../../types/Max";

@Component({
  selector: "app-prefix-gt5",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-gt5.component.html",
  styleUrl: "./prefix-gt5.component.less",
})
export class PrefixGt5Component extends PrefixComponent<string> {
  public max: Max;

  public constructor() {
    super({ updateOn: "blur" });
    this.max = 999999999999;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["gt5"];
  }
}
